<template>
  <div class="freightmode">
    <div class="freightmode__contain row m-0">
      <div class="freightmode__box"
          @click="chkFrgMode('AIR')">
        <img :src="getIcon('AIR')">
        <h1>Air</h1>
        <p>Faster shipping with Air Courier and Air Cargo Service</p>
      </div>
      <div class="freightmode__box" @click="chkFrgMode('OCEAN')">
        <img :src="getIcon('OCEAN')">
        <h1>Ocean</h1>
        <p>Our Ocean Freight Range from LCL to FCL</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'freight_mode_ctc',
  data () {
    return {
      isActiveAir: false,
      isActiveOcean: false,
      isHoverAir: true,
      isHoverOcean: false,
      data: {
        serviceHead: 'AIR'
      }
    }
  },
  methods: {
    chkFrgMode (typeMode) {
      this.data.serviceHead = typeMode
      if (typeMode === 'AIR') {
        this.isActiveAir = true
        this.isActiveOcean = false
      } else if (typeMode === 'OCEAN') {
        this.isActiveAir = false
        this.isActiveOcean = true
      }
      const typeShipment = 'type-shipment'
      this.$router.push({
        name: 'RequestShipmentContract',
        params: { step: typeShipment },
        query: {mode: typeMode}
      })
      this.$emit('inputData', this.data)
    },

    getIcon (type) {
      if (type === 'AIR') {
        return require('@/assets/image/icon/cargo-plane.svg')
      } else if (type === 'OCEAN') {
        return require('@/assets/image/icon/cargo-ship.svg')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/FreightMode.vue